const ExigenciaCelda = ({...props}) => {
	const {siglaExigencia, descripcionExigencia} = props.data
	return (
		<div className="d-flex align-items-center gap-2">
			<b>{siglaExigencia}</b>
			<span className="text-nowrap">{descripcionExigencia}</span>
		</div>
	)
}
export default ExigenciaCelda;
